import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    user: null,
    userRoles: {},
    fetchingUserError: false,
    fetchingUserInProgress: null,

    allRoles: [],
    selectedRole: null,
    fetchingRolesError: false,
    fetchingRolesInProgress: null,

    allApps: [],
    fetchingAppsError: false,
    fetchingAppsInProgress: null,
};

const homeSlice = createSlice({
    name: 'home',
    initialState,
    reducers: {
        fetchUserStart(state, { payload }) {
            state.fetchingUserInProgress = true;
            state.fetchingUserError = false;
        },
        fetchUserSuccess(state, { payload }) {
            state.fetchingUserInProgress = false;
            state.user = payload;
        },
        resetState(state, { payload }) {
            state.user = {};
            state.userRoles = {};
            state.fetchingUserError = false;
            state.fetchingUserInProgress = null;

            state.allRoles = [];
            state.selectedRole = null;
            state.fetchingRolesError = false;
            state.fetchingRolesInProgress = null;

            state.allApps = [];
            state.fetchingAppsError = false;
            state.fetchingAppsInProgress = null;
        },
        fetchUserFailed(state, { payload }) {
            state.fetchingUserInProgress = false;
            state.fetchingUserError = payload;
        },
        fetchRolesStart(state) {
            state.fetchingRolesInProgress = true;
            state.fetchingRolesError = false;
        },
        fetchRolesSuccess(state, { payload }) {
            state.fetchingRolesInProgress = false;
            state.allRoles = payload[0];
        },

        fetchRolesFailed(state, { payload }) {
            state.fetchingRolesInProgress = false;
            state.fetchingRolesError = payload;
        },
        fetchAppsStart(state) {
            state.fetchingAppsInProgress = true;
            state.fetchingAppsError = false;
        },
        fetchAppsSuccess(state, { payload }) {
            state.fetchingAppsInProgress = true;
            state.allApps = payload;
        },

        fetchAppsFailed(state, { payload }) {
            state.fetchingAppsInProgress = false;
            state.fetchingAppsError = payload;
        },
        setSelectedRole(state, { payload }) {
            state.selectedRole = payload ? state.allRoles.find((role) => role.id === payload) : null;
        },
    },
});

export const homeReducer = homeSlice.reducer;
export const homeActions = homeSlice.actions;
